// Head tags for pages with their own title; also baked into static shells by scripts/prerender-home.js.
const SITE = 'Word Labyrinth';

export const PAGE_META = {
    '/leaderboard': t => ({ title: t('leaderboard.meta.title'), description: t('leaderboard.meta.description') }),
    '/privacy': t => ({ title: `${t('legal.privacy.title')} | ${SITE}`, description: t('legal.privacy.metaDescription') }),
    '/terms': t => ({ title: `${t('legal.terms.title')} | ${SITE}`, description: t('legal.terms.metaDescription') }),
    '/impressum': t => ({ title: `${t('legal.impressum.title')} | ${SITE}`, description: t('legal.impressum.metaDescription') }),
    '/delete-account': t => ({ title: t('settings.deletePage.metaTitle') }),
    '/deletion-status': t => ({ title: t('settings.deletionStatus.metaTitle'), robots: 'noindex' }),
};
